import { render, staticRenderFns } from "./ItemMeasurements.vue?vue&type=template&id=29636c26"
import script from "./ItemMeasurements.vue?vue&type=script&lang=js"
export * from "./ItemMeasurements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports